import { useNarrow } from '../../../lib/use-narrow';
import { DesktopHomeHeader } from './DesktopHomeHeader';
import { MobileHomeHeader } from './MobileHomeHeader';

export function HomeHeader() {
  const narrow = useNarrow();
  return narrow ? <MobileHomeHeader /> : <DesktopHomeHeader />;
}
